/* eslint-disable react/prefer-stateless-function */
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


class CustomDropDownArray extends Component {
  render() {
    const {
      customLabel,
      input,
      meta: { touched, error },
      options = [],
      placeholder,
    } = this.props;

    const hasError = touched && error !== undefined;
    const renderSelectOptions = option => (<option key={option.value} value={option.value}>{option.label}</option>);

    return (
      <div className="input-container">
        <label>
          {customLabel}
        </label>
        <div className="input-wrapper">
          <select
            {...input}
            onChange={(value) => { input.onChange(value); }}
            className={classNames({
              touched, error: hasError, ok: !hasError, empty: !input.value, 'not-empty': input.value,
            })}
          >
            <option className="first-value" value="">{placeholder}</option>
            {options && options.map(renderSelectOptions)}
          </select>
          {(hasError && touched) &&
            <div className="error-icon">
              <i className="fa fa-exclamation-circle" />
            </div>}
          {(!hasError && touched) &&
            <div className="ok-icon">
              <i className="fa fa-check" />
            </div>}
          {hasError && <div className="error-message">{error}</div>}
        </div>
      </div>
    );
  }
}

CustomDropDownArray.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  // meta: PropTypes.shape({
  //   touched: PropTypes.bool,
  //   error: PropTypes.bool,
  // }),
  placeholder: PropTypes.string,
};

CustomDropDownArray.defaultProps = {
  placeholder: '',
  // meta: {
  //   error: false,
  //   touched: false,
  // },
};

export default CustomDropDownArray;
